<!-- 创建题库 -->
<template>
  <div class="detailExamBank">
    <div class="nav-bar">
      <div class="nav-left">
        <el-form inline>
          <el-form-item label="题目名称:">
            <el-input v-model="question_name" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="题目类型:">
            <el-select
              v-model="question_type"
              class="select"
              placeholder="请选择"
              :clearable="true"
            >
              <template v-for="item in bankTypeList">
                <el-option :key="item.key" :label="item.label" :value="item.key" />
              </template>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="nav-right">
        <el-button type="primary" @click="handleBtn('筛选')">筛选</el-button>
        <el-button type="primary" @click="handleBtn('创建题目')">创建题目</el-button>
      </div>
    </div>
    <el-table v-loading="tableLoading" :data="tableData" style="width: 100%; font-size: 14px">
      <el-table-column prop="question_name" label="题目名称" fixed="left">
        <template slot-scope="scope">
          <el-tooltip
            popper-class="table_tooltip"
            effect="dark"
            :content="scope.row.question_name"
            placement="top"
          >
            <Ellipsis :str="scope.row.question_name" suffix="..." :max-length="20"></Ellipsis>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="question_type" label="题目类型">
        <template slot-scope="scope">
          {{ bankTypeList[scope.row.question_type].label }}
        </template>
      </el-table-column>
      <el-table-column prop="call_num" label="调用次数"></el-table-column>
      <el-table-column prop="answered_num" label="已答人数"></el-table-column>
      <el-table-column prop="accuracy" label="正确率">
        <template slot-scope="scope">
          {{ scope.row.accuracy ? scope.row.accuracy + '%' : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button
            @click="tableActionFun({ action: '编辑', row: scope.row })"
            type="text"
            style="font-size: 14px"
          >
            编辑
          </el-button>
          <el-button
            @click="
              () => {
                delDialogVisible = true;
                rowTemp = scope.row;
              }
            "
            type="text"
            style="font-size: 14px"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
      <div slot="empty"><NoData></NoData></div>
    </el-table>
    <el-dialog title="提示" :visible.sync="delDialogVisible" width="30%" center>
      <div style="text-align: center; font-size: 20px">确定删除该题目吗?</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="
            () => {
              delDialogVisible = false;
              tableActionFun({ action: '删除', row: rowTemp });
            }
          "
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
    <el-pagination
      class="pagination"
      style="background-color: #ffffff"
      :current-page="tableCurPage"
      :page-size="tablePageSize"
      :total="tableTotal"
      @current-change="currentChangeFun"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="g_pageSizesConfig"
      @size-change="handleSizeChange"
    />
  </div>
</template>

<script>
import { mixinTable } from '../mixin/table.js';
import { GetQuestionList, DeleteQuestion } from '@/api/examBankManagement';
import Ellipsis from '@/components/ellipsis';

export default {
  name: 'DetailExamBank',
  components: { Ellipsis },
  mixins: [mixinTable],
  props: {},
  data() {
    return {
      keyword1: '',
      keyword2: '',
      question_name: '',
      question_type: '',
    };
  },
  computed: {
    bankTypeList() {
      return [
        { label: '全部', key: 0 },
        { label: '单选', key: 1 },
        { label: '多选', key: 2 },
      ];
    },
    // 题库id
    bank_id() {
      return this.$route.query.bank_id;
    },
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    // 设置面包屑
    const breadcrumb = [
      { menu_name: '考试管理', menu_path: '' },
      { menu_name: '题库管理', menu_path: 'examBankManagement' },
      { menu_name: '进入题目列表' },
    ];
    this.$store.commit('user/setBreadcrumb', breadcrumb);
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    // 查询表格列表
    async getTaleData() {
      this.tableLoading = true;
      try {
        const res = await GetQuestionList({
          page_index: this.tableCurPage, // 分页码
          page_size: this.tablePageSize, // 每页条数
          question_name: this.question_name, // 题目名称
          question_type: this.question_type || 0, // 题目类型
          bank_list: [Number(this.bank_id)], // 题库id
        });
        this.tableTotal = res.total || 0;
        this.tableData = res.question_list || [];
      } catch (error) {
        this.$message.error(error.message);
        this.tableLoading = false;
      }
      this.tableLoading = false;
    },
    /** 表格操作
     * @description: 表格操作事件
     * @param {string} action 操作名称
     * @param {object} row 操作行数据
     * @return {*} void
     */
    async tableActionFun({ action, row }) {
      switch (action) {
        case '编辑':
          this.g_tourl(
            `/saas/examBankManagement/addExam.html?bank_id=${this.bank_id}&&question_id=${row.question_id}`,
          );
          break;
        case '删除':
          // 删除=>重新请求数据
          this.tableLoading = true;
          try {
            await DeleteQuestion({
              question_id: [Number(row.question_id)],
            });
            this.$message.success('删除成功');
            this.getTaleData();
          } catch (error) {
            this.$message.error(error.message);
          }
          this.tableLoading = false;
          break;
        default:
          break;
      }
    },
    // 操作按钮
    handleBtn(action) {
      switch (action) {
        case '筛选':
          this.reloadTable(true);
          break;
        case '创建题目':
          this.g_tourl(`/saas/examBankManagement/addExam.html?bank_id=${this.bank_id}`);
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss">
//分页
.pagination {
  margin-top: 12px;
  text-align: right;

  & ::v-deep .el-pager li.number {
    color: #606266;
  }

  & ::v-deep .el-pager li.active {
    color: #2f96ff !important;
  }

  & ::v-deep .el-input__inner {
    width: 46px;
    border-radius: 3px;
    height: 24px;
  }
}
.table_tooltip {
  max-width: 300px;
}
</style>

<style lang="scss" scoped>
.detailExamBank {
  // 条件栏
  .nav-bar {
    padding-bottom: 20px;
    &::after {
      content: '';
      display: block;
      clear: both;
    }
    .nav-left {
      display: inline-block;
    }
    .nav-right {
      float: right;
    }
  }
}
</style>
